<script>
import { SiteSettings } from '@/api/'
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  created() {
    this.fetchNewsletter()
  },
  methods: {
    fetchNewsletter() {
      SiteSettings.get().then(response => {
        this.$set(this.form, 'newsletter', response.data['newsletter'])
      })
    }
  },
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            new fields.Header({
              text:
                'Żeby edytować newsletter przejdź do zakładki "Ustawienia > Konfiguracja > Newsletter."',
              type: 'h4'
            }),
            ...this.getCommonFields(),
            new fields.ColorSelect({
              label: 'Kolor (domyślnie Podstawowy)',
              modelPath: [this, 'form', 'color']
            }),
            new fields.Input({
              label: 'Tytuł',
              modelPath: [this, 'form', 'newsletter', 'title'],
              disabled: true,
              multilingual: true
            }),
            new fields.Input({
              label: 'Tekst',
              modelPath: [this, 'form', 'newsletter', 'text'],
              multilingual: true,
              disabled: true,
              type: 'textarea'
            }),
            new fields.Input({
              label: 'Tekst przycisku',
              modelPath: [this, 'form', 'newsletter', 'button_text'],
              disabled: true,
              multilingual: true
            }),
            new fields.Input({
              label: 'Tekst podpowiedzi',
              modelPath: [this, 'form', 'newsletter', 'input_placeholder'],
              disabled: true,
              multilingual: true
            }),
            new fields.Input({
              label: 'Tekst przy zgodzie',
              modelPath: [this, 'form', 'newsletter', 'agreement_text'],
              multilingual: true,
              disabled: true,
              type: 'textarea'
            })
          ]
        }
      ]
    }
  }
}
</script>
